import * as React from "react";
import styles from "@styles/pages/innovation/index.module.scss";
import {useRef} from "react";
import Image from "next/image";
import {useInView} from "framer-motion";
import SILink from "@components/link/silink";
import {strapi} from "@api/Strapi";

// @ts-ignore
function Innovation({InnovationList}) {

    /**
     * these variables are used to animate the left and right image when this view are on screen.
     */
    const ref = useRef(null);
    const isInView = useInView(ref, {once: false});

    /***
     * This page includes the header and footer components
     * The page contain list of data in that we have image, title, subtitle and description.
     */
    return (
        <>
            <section className={styles.banner}>
                <div className={'details_container'}>
                    <div className={'sidr_text'}>sidr</div>
                    <h2 className={'title_text'}>innovation</h2>
                    <div className={'description'}>
                        SIDR believes in nonstop innovation that results in nutritious food, accessible to everyone,
                        while supporting and caring for our people and communities near and far.
                    </div>
                </div>
            </section>
            <section className={styles.container}>
                <div className={'description'}>
                    <h1>buying honey online, 100% trusted.</h1>
                    <span>
                        The goal has always been to grow beyond quality products to evolve with the changing behavior of consumers. We’ve recently stretched our innovation and brand across two categories: honey, and honey packet. Our most recent developments buying honey online include:
                    </span>
                </div>
                <div className={'list_items'}>
                    {
                        InnovationList.map((innovation: any, index: number) => {
                            return (<div className={'item'} key={'innovation-' + index}>
                                <div className={'detail'}
                                     ref={innovation.attributes.Left_Animation_Image.data ? ref : null}>
                                    {
                                        innovation.attributes.Left_Animation_Image.data &&
                                        <div className={`images ${isInView ? 'image_animation' : ''}`}>
                                            <Image
                                                src={innovation.attributes.Left_Animation_Image.data.attributes.url}
                                                alt={innovation.attributes.Left_Animation_Image.data.attributes.alternativeText ?? 'SIDR'}
                                                fill={true}/>
                                            <Image
                                                src={innovation.attributes.Right_Animation_Image.data.attributes.url}
                                                alt={innovation.attributes.Left_Animation_Image.data.attributes.alternativeText ?? 'SIDR'}
                                                fill={true}/>
                                        </div>
                                    }
                                    <div className="title_normal">sidr</div>
                                    <div className={'title_medium'}>{innovation.attributes.Title}</div>
                                    <div className={`info ${innovation.attributes.Title}`}
                                         dangerouslySetInnerHTML={{__html: innovation.attributes.Description}}></div>
                                    <SILink href={'/' + innovation.attributes.Link}>shop now</SILink>
                                </div>
                                <div className={'img_box'}>
                                    <Image src={innovation.attributes.Image.data.attributes.url}
                                           alt={innovation.attributes.Image.data.attributes.alternativeText ?? 'SIDR'}
                                           loading={"lazy"} fill={true}></Image>
                                </div>
                            </div>)
                        })
                    }
                </div>
            </section>
        </>
    )
}

export async function getServerSideProps(context: any) {

    const seoDetails = {
        // title: `Innovation | SIDR®`,
        url: context.resolvedUrl,
        // keyword: 'nutritious food',
        // description: 'SIDR® believes in nonstop innovation that results in nutritious food, accessible to everyone, while caring for our people and communities near and far.'
    };

    try {
        const response = await strapi.getInnovationList();
        if (response.status == 200 && response.data && response.data.data) {
            return {props: {InnovationList: response.data.data, seoDetails}}
        }
        return {props: {InnovationList: [], seoDetails}}
    } catch (e) {
        console.log(e)
        return {props: {InnovationList: [], seoDetails}}
    }
}

export default Innovation;
